// Copyright (c) Microsoft. All rights reserved.

import { makeStyles, shorthands } from '@fluentui/react-components';
import React from 'react';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import * as utils from './../../utils/TextUtils';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkSuperSub from 'remark-supersub';

const useClasses = makeStyles({
    content: {
        wordBreak: 'break-word',
        '& p': {
            marginTop: '0',
            marginBottom: '0',
        },
        '& pre': {
            backgroundColor: 'black',
            color: 'white',
            ...shorthands.padding('15px'),
            ...shorthands.borderRadius('5px'),
        },
        '& code': {
            textWrap: 'wrap',
        },
    },
    markdown: {
        '& a': {
            "text-decoration": "none"
        }
    }
});

interface ChatHistoryTextContentProps {
    message: IChatMessage;
}

export const ChatHistoryTextContent: React.FC<ChatHistoryTextContentProps> = ({ message }) => {
    const classes = useClasses();

    const content =
        message.content === '{}'
            ? "I am sorry, but I can't find anything related to your question."
            : utils.formatChatTextContent(message);
    return (
        <div className={classes.content}>
            <ReactMarkdown className={classes.markdown} remarkPlugins={[remarkGfm, remarkSuperSub]} components={{ sub: 'sub', sup: 'sup' }}>
                {content}
            </ReactMarkdown>
        </div>
    );
};
